import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AdditionalFieldWrapper from '../AdditionalFieldWrapper';
import TextInput from '../../../common/components/TextInput';

/**
 * New Ticket Additional field component for follow-up questions
 * 'Additional' fields AKA follow up questions are simple string
 *    values that end up appended to the ticket comment.
 */
export class AdditionalQuestions extends Component {
  constructor() {
    super();

    this.state = {
      displayFields: true
    };

    this.handleDisplayFieldsChange = this.handleDisplayFieldsChange.bind(this);
    this.getAdditionalFields = this.getAdditionalFields.bind(this);
  }

 /**
  * Event handler to toggle the display of additional fields
  * @param {Object} event
  */
  handleDisplayFieldsChange(event) {
    this.setState({
      ...this.state,
      displayFields: event.target.value
    });
  }

 /**
  * Get additional fields (follow up questions) by provided reason value
  * @param   {questions} The questions to present
  * @returns {Array}  fields
  */
  getAdditionalFields(questions) {
    return questions.map(question => (
      <TextInput
        key={question}
        name={question}
        label={question}
        value={this.props.value[question] || ''}
        onChange={this.props.onChange}
        classes="animated fadeIn"
      />
    ));
  }

  /**
   * Get filtered additional fields according to current ticket state
   * If none are applicable return null otherwise render them inside a wrapper
   */
  render() {
    const { questions } = this.props;
    const additionalFields = this.getAdditionalFields(questions);
    if (!additionalFields.length) {
      return null;
    }

    return (
      <AdditionalFieldWrapper
        onChange={this.handleDisplayFieldsChange}
        showAddFields={this.state.displayFields}>
          {additionalFields}
      </AdditionalFieldWrapper>
    );
  }
}

AdditionalQuestions.defaultProps = {
  value: {}
};

AdditionalQuestions.propTypes = {
  /** The form name and schema key */
  name: PropTypes.string.isRequired,
  /** Callback for change event */
  onChange: PropTypes.func.isRequired,
  /** The current field value */
  value: PropTypes.object.isRequired,
  /** the questions to ask */
  questions: PropTypes.array.isRequired
};

export default AdditionalQuestions;
